var React = require('react');

function CalendarInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 3.66656H25.0001V25H1V3.66656Z","stroke":"#212355","strokeWidth":"1.5","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M25.0001 9.00003H1","stroke":"#212355","strokeWidth":"1.5","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M6.33383 3.66668V1","stroke":"#212355","strokeWidth":"1.5","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M19.6666 3.66668V1","stroke":"#212355","strokeWidth":"1.5","strokeLinecap":"round","key":3})]);
}

CalendarInline.defaultProps = {"viewBox":"0 0 26 26","fill":"none"};

module.exports = CalendarInline;

CalendarInline.default = CalendarInline;
